import {BehaviorSubject, Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class DatosSeccionWizardEventsService {

    private save$ = new Subject<void>();
    private doneSave$ = new Subject<any>();
    private destroy$ = new Subject();
    private goToStep$ = new Subject<number>();
    private _arrowsState$ = new Subject<boolean>();
    private readOnly$ = new BehaviorSubject<boolean>(false);

    constructor() {
    }

    get onSave(): Observable<void> {
        return this.save$.asObservable().pipe(takeUntil(this.destroy$));
    }

    stopSubscriptions() {
        this.destroy$.next();
    }

    save() {
        this.save$.next();
    }

    doneSave(val: any) {
        this.stopSubscriptions();
        this.doneSave$.next(val);
    }

    get onDoneSave(): Observable<any> {
        return this.doneSave$;
    }

    goToStep(stepNumber: number) {
        this.goToStep$.next(stepNumber);
    }

    get goToStepEvent(): Observable<any> {
        return this.goToStep$;
    }

    changeArrowState(show: boolean) {
        this._arrowsState$.next(show);
    }

    get arrowsState$(): Subject<boolean> {
        return this._arrowsState$;
    }

    setReadOnly(val: boolean) {
        this.readOnly$.next(val);
    }

    get readOnlyEvent(): Observable<boolean> {
        return this.readOnly$;
    }
}
